"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const updateEnrolmentFields_1 = require("./updateEnrolmentFields");
const isParentContent = (command, content) => command.rootContentId === content._id;
const isDirectlyAssigned = (enrolment) => enrolment.direct;
// only update due date if content is parent content or when child content is not directly assigned
const toUpdateDueDate = (commad, content, enrolment) => isParentContent(commad, content) || !isDirectlyAssigned(enrolment);
function changeDueDateOfEnrolment(command, content, enrolment) {
    try {
        if (toUpdateDueDate(command, content, enrolment)) {
            updateEnrolmentFields_1.updateDueDateInEnrolment(command, enrolment);
        }
        return enrolment;
    }
    catch (error) {
        throw new Error('Error in changeDueDateOfEnrolment ' + error);
    }
}
exports.default = changeDueDateOfEnrolment;
//# sourceMappingURL=changeDueDateOfEnrolment.js.map